<template>
    <div id="app">
        <div class="header">
            <div class="logo_img" @click="logoClick">
                <div style="display:flex; align-items: center; float:left; height: 65px;">
                    <div class="header-logo">
                        <img id="header-img" src="../assets/logo1.png" >
                    </div>
                </div>
                <div style="display:flex; float:left; height: 65px;">
                    <div class="header-important">
                        <div class="company_name">黙娱网络</div>
                        <div class="header-title company_name">panbaonet.com</div>
                    </div>
                </div>
            </div>
            <div id="menu_index">
                <!-- web端菜单导航 -->
                <el-menu v-if="seen" :default-active="activeIndex" class="el-menu-demo" menu-trigger="click" text-color="#333" style="height: 65px; border:0;" mode="horizontal" @select="handleSelect">
                    <el-menu-item index="1" class="header-title">首页</el-menu-item>
                    <el-submenu index="2">
                        <template slot="title">产品与解决方案</template>
                        <el-menu-item index="2-1">产品形态</el-menu-item>
                        <el-menu-item index="2-2">后台系统</el-menu-item>
                        <el-menu-item index="2-3" disabled>行业定制</el-menu-item>
                        <el-menu-item index="2-4" disabled>解决方案</el-menu-item>
                    </el-submenu>
                    <el-menu-item index="3" class="header-title">产品特点</el-menu-item>
                    <el-menu-item index="4" class="header-title">合作伙伴</el-menu-item>
                    <el-menu-item index="5" class="header-title">关于我们</el-menu-item>
                </el-menu>
                <!-- 手机端菜单导航 v-bind:style="{backgroundColor:'#409EFF'}" -->
                <el-menu v-if="!seen" :default-active="activeIndex" class="el-menu-demo" menu-trigger="click" text-color="#333" style="height: 65px; border:0;" mode="horizontal" @select="handleSelectMobile">
                    <el-submenu index="1" class="header-title mobile_menu">
                        <template slot="title">{{currentMenu}}</template>
                        <el-menu-item index="1" class="header-title">首页</el-menu-item>
                        <el-menu-item index="2-2" class="header-title">后台系统</el-menu-item>
                        <el-menu-item index="2-1" class="header-title">产品形态</el-menu-item>
                        <el-menu-item index="3" class="header-title">产品特点</el-menu-item>
                        <el-menu-item index="4" class="header-title">合作伙伴</el-menu-item>
                        <el-menu-item index="5" class="header-title">关于我们</el-menu-item>
                    </el-submenu>
                </el-menu>
            </div>
            <div v-if="seen" style="float: right; display: flex;align-items: center; height: 100%;">
                <el-button type="primary" style="margin-right: 60px;" class="header-title" @click="publish" round>发布需求</el-button>
                <el-button type="text" style="margin-right: 20px;" class="header-title" @click="login">登录</el-button>
                <el-button type="text" class="header-title" @click="register" round>注册</el-button>
            </div>
        </div>
        <div class="container" style="clear: both;">
            <router-view></router-view>
        </div>

        <div style="width: 90%;margin: 20px auto;">
            <div style="height:1px;padding:0;background-color:#999;">
            </div>
        </div>
        <div style="width: 90%;margin: 20px auto;">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12">
                    <p class="footer_font">邮箱：jamie.ren@panbaonet.com</p>
                    <div style="margin: auto;" class="footer_font">
                        互联网ICP备案：沪ICP备18018268号-1
                    </div>
                    <div style="margin: auto;" class="footer_font">
                        ©panbaonet.com 上海黙娱网络科技有限公司版权所有
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12">
                    <div><img :src="company.qrcode" style="width: 100px;height: 100px;border: 0"/></div>
                    <div class="footer_font">商务洽谈微信</div>
                </el-col>
            </el-row>
        </div>
        <div id="back_to_top" ref="btn" @click="backTop" style="display: none;">
            <p style="font-size: 0.625em; font-weight: bold">TOP</p>
            <img src="../assets/other/launch.png" style="height: 45px;width: 35px" />
        </div>


        <!-- 注册界面 -->
        <el-dialog title="用户注册" :visible.sync="registerFormVisible">

        <el-form :model="registerForm" label-width="100px" :rules="addFormRules1" ref="registerForm">
            <el-form-item label="用户名" prop="roleName">
            <el-input v-model="registerForm.roleName" auto-complete="off"></el-input>
            </el-form-item>

            <el-form-item label="邮件地址" prop="roleEmail">
            <el-input v-model="registerForm.roleEmail" auto-complete="off"></el-input>
            </el-form-item>

            <el-form-item label="登录密码" prop="rolePassword">
            <el-input v-model="registerForm.rolePassword" auto-complete="off"></el-input>
            </el-form-item>

            <el-form-item label="确认密码"  prop="againPassword" label-width="100px">
            <el-input v-model="registerForm.rolePassword" auto-complete="off"></el-input>
            </el-form-item> 

        </el-form>

        <div slot="footer" class="dialog-footer">
            <el-button @click.native="registerFormVisible = false">取消</el-button>
            <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
        </el-dialog>     
        <!-- 登录界面 -->
        <el-dialog title="用户登录" :visible.sync="loginFormVisible">

        <el-form :model="loginForm" label-width="100px" :rules="addFormRules2" ref="loginForm">
            <el-form-item label="用户名" prop="roleName">
            <el-input v-model="loginForm.roleName" auto-complete="off"></el-input>
            </el-form-item>

            <el-form-item label="登录密码" prop="rolePassword">
            <el-input v-model="loginForm.rolePassword" auto-complete="off"></el-input>
            </el-form-item>

        </el-form>

        <div slot="footer" class="dialog-footer">
            <el-button @click.native="loginFormVisible = false">取消</el-button>
            <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
        </el-dialog>  

    <!-- 发布界面 -->
    <el-dialog title="发布需求" :visible.sync="demandFormVisible">

      <el-form :model="demandForm" label-width="100px" :rules="addFormRules3" ref="demandForm">
        <el-form-item label="联系人" prop="contactName">
          <el-input v-model="demandForm.contactName" auto-complete="off"></el-input>
        </el-form-item>

        <el-form-item label="邮件地址" prop="contactEmail">
          <el-input v-model="demandForm.contactEmail" auto-complete="off"></el-input>
        </el-form-item>

        <el-form-item label="电话号码" prop="phoneNumber">
          <el-input v-model="demandForm.phoneNumber" auto-complete="off"></el-input>
        </el-form-item>

        <el-form-item label="需求类型"  prop="demandType" label-width="100px">
          <el-select v-model="demandForm.demandType" placeholder="需求类型"  id="demandType" style="width: 200px">
            <el-option label="小程序" value="0"></el-option>
            <el-option label="公众号" value="1"></el-option>
            <el-option label="App" value="2"></el-option>
            <el-option label="后台管理" value="3"></el-option>
          </el-select>
        </el-form-item> 

      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click.native="demandFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
      </div>
    </el-dialog>           
    </div>
</template>

<script>
    export default {
        name: "Layout",
        data() {
            return {
                activeIndex: '1',
                company:{
                    qrcode: require("../../static/other/contactCode.jpg"),
                },
                scroll: '',
                timer: '',
                seen: true,
                currentMenu:'首页',
                registerFormVisible: false,
                loginFormVisible: false,
                demandFormVisible: false,
                addLoading: false,
                //新增界面数据
                registerForm: {
                    roleName: "",
                    roleEmail: "",
                    rolePassword: "",
                    againPassword: ""
                },                
                addFormRules1: {
                    roleName: [
                    {
                        required: true,
                        message: "输入用户名",
                        trigger: "blur"
                    }
                    ],
                    roleEmail: [
                    {
                        required: true,
                        message: "输入用户邮箱",
                        trigger: "blur"
                    }
                    ],
                    rolePassword: [
                    {
                        required: true,
                        message: "输入用户密码",
                        trigger: "blur"
                    }
                    ],
                    againPassword: [
                    {
                        required: true,
                        message: "输入用户密码",
                        trigger: "blur"
                    }
                    ]
                },
                
                //新增界面数据
                loginForm: {
                    roleName: "",
                    rolePassword: ""
                },     
                addFormRules2: {
                    roleName: [
                    {
                        required: true,
                        message: "输入用户名",
                        trigger: "blur"
                    }
                    ],

                    rolePassword: [
                    {
                        required: true,
                        message: "输入用户密码",
                        trigger: "blur"
                    }
                    ],

                },

                //新增界面数据
                demandForm: {
                    contactName: "",
                    contactEmail: "",
                    phoneNumber: "",
                    demandType: ""
                },  
                addFormRules3: {
                    contactName: [
                    {
                        required: true,
                        message: "输入联系人",
                        trigger: "blur"
                    }
                    ],

                    contactEmail: [
                    {
                        required: true,
                        message: "输入电子邮件",
                        trigger: "blur"
                    }
                    ],

                    phoneNumber: [
                    {
                        required: true,
                        message: "输入联系电话",
                        trigger: "blur"
                    }
                    ],

                    demandType: [
                    {
                        required: true,
                        message: "选择需求类型",
                        trigger: "blur"
                    }
                    ]

                },
                                 
            };
        },
        methods: {
            handleSelect(key) {
                switch (key){
                    case '1':
                        this.$router.push({name: "Index"});
                        break;
                    case '2-1':
                        window.location.hash = "#产品介绍";
                        break;
                    case '2-2':
                        this.$router.push({name: "Manage"});
                        break;
                    case '2-3':
                        this.$router.push({name: "Fashion"});
                        break;
                    case '3':
                        this.$router.push({name: "Index"});
                        window.location.hash = "#产品特点";
                        break;
                    case '4':
                        this.$router.push({name: "Index"});
                        window.location.hash = "#合作伙伴";
                        break;
                    case '5':
                        this.$router.push({name: "Index"});
                        window.location.hash = "#关于我们";
                        break;
                }
            },
            handleSelectMobile(key) {
                switch (key){
                    case '1':
                        this.$router.push({name: "Index"});
                        this.currentMenu='首页';
                        break;
                    case '2-1':
                        this.$router.push({name: "Index"});
                        window.location.hash = "#产品介绍";
                        this.currentMenu='首页';
                        break;
                    case '2-2':
                        this.$router.push({name: "Manage"});
                        this.currentMenu='后台系统';
                        break;
                    case '2-3':
                        this.$router.push({name: "Fashion"});
                        break;
                    case '3':
                        this.$router.push({name: "Index"});
                        window.location.hash = "#产品特点";
                        this.currentMenu='首页';
                        break;
                    case '4':
                        this.$router.push({name: "Index"});
                        window.location.hash = "#合作伙伴";
                        this.currentMenu='首页';
                        break;
                    case '5':
                        this.$router.push({name: "Index"});
                        window.location.hash = "#关于我们";
                        this.currentMenu='首页';
                        break;
                }
            },
            handleScroll(){
                this.scroll = document.documentElement.scrollTop + document.body.scrollTop; //获取滚动后的高度
                if( this.scroll >600 ){  //判断滚动后高度超过400px,就显示
                    this.$refs.btn.style.display = 'block';
                }else{
                    this.$refs.btn.style.display = 'none'
                }
            },
            backTop(){ //当点击标签的时候,使用animate在200毫秒的时间内,滚到顶部
                this.timer = setInterval(() => {
                    let osTop = document.documentElement.scrollTop || document.body.scrollTop;
                    let ispeed = Math.floor(-osTop / 5)
                    document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
                    if (osTop === 0) {
                        clearInterval(this.timer)
                    }
                }, 30)
            },
            login(){
                this.loginFormVisible = true;
            },
            register(){
                this.registerFormVisible = true;
            },
            publish(){
                this.demandFormVisible = true;
            },
            menuSeen(){
                // 屏幕尺寸
                let screenHeight=document.body.clientWidth;
                if(screenHeight>415){
                    this.seen=true;
                }else{
                    this.seen=false;
                }
            },
            addSubmit() {
                this.$refs.addForm.validate(valid => {
                if (valid) {
                //判断是否填写完整  --true
                this.$confirm("确认提交吗？", "提示", {}).then(() => {
                    this.addLoading = true;
                    var para = Object.assign({}, this.addForm);
                    // 将token传入参数中
                    // para.Token = getCookie("token");
                    // 发保存请求
                    this.$http.get(app_.root+'/addRolePermission.php', {
                        params: {
                        // Role: para.Name,
                        // Token: para.Token
                        roleName:para.roleName,
                        roleEmail: para.roleEmail,
                        roleType: para.roleType,
                        rolePassword: para.rolePassword
                        }
                    })
                    .then(
                        function(response) {

                        this.addLoading = false;

                        var status = response.data.code;
                        
                        if (status == 200) {
                            // 表单重置
                            console.log('status:' + status);
                            //this.$refs["addForm"].resetFields();
                            this.addFormVisible = false;
                            this.getRolePermissionList();
                        } else if (status === 40001) {
                            this.$message({
                            showClose: true,
                            type: "warning",
                            message: response.data.Result
                            });
                            setTimeout(() => {
                            tt.$router.push({
                                path: "/login"
                            });
                            }, 1500);
                        } else {
                            this.$message({
                            showClose: true,
                            type: "warning",
                            message: response.data.Result
                            });
                        }
                        }.bind(this)
                    )
                    // 请求error
                    .catch(
                        function(error) {
                        this.$notify.error({
                            title: "错误",
                            message: "错误：请检查网络"
                        });
                        }.bind(this)
                    );
                });
                }
                });
            },
      
            logoClick(){
                this.$router.push({name: "Index"});
                this.currentMenu='首页';
            }
        },
        
        mounted() {
            this.menuSeen()
            window.addEventListener('scroll', this.handleScroll)
        },
    }
</script>

<style scoped>
    .logo_img{
        float:left;
        width: 30%;
        cursor: pointer;
    }
    #back_to_top{
        position: fixed;
        bottom: 50px;
        right: 30px;
        cursor: pointer
    }
    .header-title{
        font-size: 1em;
    }
    .company_name{
        font-weight: normal;
        font-size: 1em;
    }
    .footer_font{
        font-size: 1em;
    }
    #menu_index{
        float: left; width: 50%;height: 100%
    }
    .header{
        margin: auto;
        width: 90%;
        height: 65px;
        /*background: #F56C6C;*/
    }
    @media screen and (max-device-width: 415px) {
        .logo_img{
            float:left;
            width: auto;
            cursor: pointer;
        }
        #back_to_top{
            position: fixed;
            bottom: 50px;
            right: 5px;
            cursor: pointer
        }
        .footer_font{
            font-size: 0.875em;
        }
        #menu_index{
            float: right;
            width: auto;
            height: 100%
        }
        .mobile_menu{

        }
    }
    #header-img{
        width: 50px;
        height: 50px;
        float: left;
        margin: auto;
    }
    .header-logo{
        height: 50px;
        width: 50px;
        align-self: center;
    }
    .header-important{
        float: left;
        margin-left: 6px;
        align-self: center;
    }

    .footer{
        display: flex;
        align-items: center;
        margin: 10px auto;
        width: 90%;
    }
    a{text-decoration: none;}
    a:visited{text-decoration: none;}
    a:hover {text-decoration: none;}
    a:active{text-decoration:none;}
</style>